import React, { useState, useEffect } from 'react';

function WebDesignVisionSection() {
  // Retype animation between Pakistan and Karachi
  const words = ['Pakistan', 'Karachi'];
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const fullWord = words[currentWordIndex];
    let timer;

    if (!isDeleting) {
      if (currentText.length < fullWord.length) {
        timer = setTimeout(() => {
          setCurrentText(fullWord.slice(0, currentText.length + 1));
        }, 120);
      } else {
        timer = setTimeout(() => {
          setIsDeleting(true);
        }, 1800);
      }
    } else {
      if (currentText.length > 0) {
        timer = setTimeout(() => {
          setCurrentText(fullWord.slice(0, currentText.length - 1));
        }, 70);
      } else {
        setIsDeleting(false);
        setCurrentWordIndex((prev) => (prev + 1) % words.length);
      }
    }

    return () => clearTimeout(timer);
  }, [currentText, isDeleting, currentWordIndex]);

  const handleDiscussClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('webdesign-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="webdesign-vision-section">
      <div className="container">
        {/* Section Header with Retype Animation */}
        <div className="webdesign-vision-header">
          <h2 className="webdesign-vision-title">
            Leading Web Design Company In{' '}
            <span className="typewriter-highlight text-red">
              {currentText}
              <span className="typewriter-cursor">|</span>
            </span>
          </h2>
        </div>

        {/* 2-Column Content Layout */}
        <div className="webdesign-vision-container">
          {/* Left Column: Vision Content */}
          <div className="webdesign-vision-left">
            <div className="webdesign-vision-subtitle-box">
              <div className="webdesign-vision-red-bar"></div>
              <h3 className="webdesign-vision-subtitle">
                Bringing Your Vision to Life with Affordable Web Design Services
              </h3>
            </div>

            <p className="webdesign-vision-desc">
              Identity is the need of brands and companies, and to create a unique identity on the web, you need an exceptional and top web design agency. We are here to help.
            </p>

            <p className="webdesign-vision-desc">
              If your website seems unattractive and difficult for the user, they might not get engaged with your content and explore further. You must have a well designed and fully developed website to build trust for your brand. A professionally designed website can always convince users to perform the desired action, No matter you have an eCommerce website or a service based business.
            </p>

            <p className="webdesign-vision-desc">
              Our <a href="/web-development/" className="webdesign-vision-link" onClick={handleDiscussClick}>web development services</a> are here for you to deliver customized, professional, and responsive websites that align with your business, industry, and objectives.
            </p>
          </div>

          {/* Right Column: Showcase Image */}
          <div className="webdesign-vision-right">
            <div className="webdesign-vision-img-wrapper">
              <img
                src="/assets/images/web-design/web-img3.jpg"
                alt="Leading Web Design Company In Pakistan / Karachi"
                className="webdesign-vision-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WebDesignVisionSection;
